import React from 'react';

import { useSelector } from 'react-redux';

import { FormattedMessage } from '@techstyle/react-intl';

import { selectPromoCodeError } from '../../slices/promoCode';

export const CartDrawerPromoCodeSubtext = () => {
  const error = useSelector(selectPromoCodeError);
  if (!error) {
    return <></>;
  }

  switch (error) {
    case 'ERROR_INVALID_GIFT_CERT':
      return (
        <FormattedMessage
          id="global_checkout.giftcard_error"
          defaultMessage="The gift card does not exist or has already been redeemed. Try again"
        />
      );
    case 'ERROR_UNAUTHORIZED':
      return (
        <FormattedMessage
          id="global_checkout.promo_code_error_unauthorized"
          defaultMessage="Please sign up or log in to apply a promo code."
        />
      );
    case 'ERROR_INVALID':
      return (
        <FormattedMessage
          id="global_checkout.promo_code_fail"
          defaultMessage="The code you entered does not exist. Try again"
        />
      );
    case 'ERROR_UNKNOWN':
    default:
      return (
        <FormattedMessage
          id="global_checkout.promo_code_error"
          defaultMessage="We’ve encountered an error. Try again"
        />
      );
  }
};
